import React, {useState, useEffect, useContext} from 'react'
import { LawyerContext } from '../../../../partials/Context'
import { Errors } from '../../../../partials/Partials';

function Blog() {
    const lawyer = useContext(LawyerContext);
    const {id} = lawyer || '';
    const [articles, setArticles] = useState([])
    const [errors, setErrors] = useState([]);
    let list = [];

    useEffect(() => {
        if (id)
        fetch(`/api/lawyer_articles/${id}`).then(res => {
            if (res.ok) {
            res.json().then(data => {
                setArticles(data)
                setErrors([])
            })
            } else {
                setErrors(['Nie udało się załadować artykułów'])
            }
        })
    }, [id])

    if (articles.length > 0) {
        articles.forEach((article, index) => {
            const {url, title, content} = article || '';
            if(index < 4) {
                list.push(
                    <div key={index} className="lawyer-article">
                        <h4>
                            <a href={url}>{title}</a>
                        </h4>
                        <p>{content.length > 250 ? `${content.slice(0,250)}...` : content}</p>
                    </div>
                )
            }
        })
    }


  return (
    <div id="blog" className="top-buffer">
        <div className="title">
            <div className="title-part">
                Twój blog
                <a href="/poradnik-prawny/" className="link">wszystkie artykuły</a>
            </div>
            <a href="/poradnik-prawny/napisz-artykul/" target="_blank" className="btn btn-primary">Dodaj artykuł na blog dla Klientów</a>
        </div>
        <div id="blog-content">
            <Errors errors={errors} />
            {list.length > 0 ? 
            <>
            <div className="lawyer-articles">
                {list}
            </div>
            <a href="/poradnik-prawny/autor/katarzyna-nowogrodzka-917/" className="btn btn-default center-block" target="_blank" rel="noreferrer">
                Pozostałe twoje publikacje
            </a>
            </> :
                <div className="sp-tooltip blue tooltip-block bottom tooltip in">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-inner">
                    <div className="tooltip-text col-sm-12">
                        <i className="fa fa-info-circle fa-2x"></i><div>Autorzy porad mają 35% więcej klientów<br/>Najlepsze porady przeczytało ponad 10 700 osób<br/>Twój artykuł będzie na stronie głównej</div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
  )
}

export default Blog